import * as React from 'react';
import { styled } from '@linaria/react';

import { range } from '@/utils';

import { KEYS } from './Synthesizer.constants';
import KeyWhite from './KeyWhite';
import KeyBlack from './KeyBlack';

interface Props {
  numberOfKeys: number;
  startingOctave: number;
  layers: number;
}

function KeyBed({ numberOfKeys, startingOctave, layers }: Props) {
  const ref = React.useRef<HTMLDivElement>(null);

  return (
    <Wrapper ref={ref}>
      {range(numberOfKeys).map((index: number) => {
        const keyName = KEYS[index % KEYS.length];
        const isSharp = keyName.includes('#');
        const octave =
          startingOctave + Math.floor(index / KEYS.length);
        const id = `${keyName}${octave}`;

        // Check if any keyboard key that maps to this note is pressed
        const isPressed = false;

        const KeyComponent = isSharp ? KeyBlack : KeyWhite;

        const isPreviousKeyPressed = false;
        const isNextKeyPressed = false;

        return (
          <KeyComponent
            key={id}
            musicalKey={id}
            isPressed={isPressed}
            isPreviousKeyPressed={isPreviousKeyPressed}
            isNextKeyPressed={isNextKeyPressed}
            handleClickKey={() => {}}
            handleReleaseKey={() => {}}
            isGlissando={false}
            setIsGlissando={() => {}}
            layers={layers}
          />
        );
      })}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  isolation: isolate;
  background: black;
`;

export default KeyBed;
